import LegalPage from "@/components/site/LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage
      eyebrow="Notice"
      title="Disclaimer"
      intro="The information, content, and services provided by Contentium Tech are intended for general educational and informational purposes only."
      downloadUrl="https://www.contentiumtech.com/Contentium_Tech_Disclaimer_v1.0.pdf"
      sections={[
        {
          id: "general",
          heading: "General Disclaimer",
          body: [
            "The information, content, and services provided by Contentium Tech are intended for general educational and informational purposes only. While we strive to ensure accuracy and relevance, we make no representations or warranties regarding completeness, reliability, or outcomes.",
          ],
        },
        {
          id: "educational",
          heading: "Educational Disclaimer",
          body: [
            "Eduzy, an initiative by Contentium Tech, provides structured learning support. However, academic outcomes depend on individual student effort, consistency, and external factors.",
            "We do not guarantee specific results, grades, or academic performance.",
          ],
        },
        {
          id: "user-responsibility",
          heading: "User Responsibility",
          body: [
            "Users are responsible for how they use the platform, interpret content, and share information. Contentium Tech shall not be held liable for any decisions made based on the use of our services.",
          ],
        },
        {
          id: "children",
          heading: "Children & Parental Responsibility",
          body: [
            "Our services may involve minors. Parents or legal guardians are responsible for supervising their child's usage, ensuring accuracy of information shared, and monitoring engagement.",
            "Contentium Tech shall not be liable for any data shared without parental oversight or for any misuse arising from such interactions.",
          ],
        },
        {
          id: "service-availability",
          heading: "Technology & Service Availability",
          body: [
            "We aim to provide reliable services; however, we do not guarantee uninterrupted access. We are not liable for service disruptions, technical issues, or downtime beyond our control.",
          ],
        },
        {
          id: "third-party",
          heading: "Third-Party Platforms",
          body: [
            "Our services may utilize third-party platforms such as messaging services, video conferencing tools, or payment gateways. We are not responsible for the performance, policies, or actions of these external platforms.",
          ],
        },
        {
          id: "liability",
          heading: "Limitation of Liability",
          body: [
            "Contentium Tech shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services, content, or platform.",
          ],
        },
      ]}
    />
  );
}
